import React, { Component } from 'react';
import { Button, cls } from "../../../../packages/components";
import { AAF_MODAL_LANDING_STB } from '../../../../actions/modal';
import store from '../../../../store';
import { showModal } from '../../../../actions/modal';
import AddAdminDeviceTask from '../../../../requests/tasks/device/AddAdminDeviceTask';
import RequestManager from '../../../../requests/RequestManager';
import Assets from '../../../../requests/apa/Asset';
import DeviceStorage from '../../../DeviceStorage/DeviceStorage';
class ButtonActualizarAlApagar extends Component {
    constructor(props) {
        super(props);
        const region = DeviceStorage.getItem("region");
        this.buttonOnDefault =  Assets.get('LandingPageClaroTv_BotonPrimario_ColorBotonPrimario_Btn_ActualizarApagar_On', '');
        this.buttonOn = Assets.get(`LandingPageClaroTv_BotonPrimario_ColorBotonPrimario_Btn_ActualizarApagar_On_${region}`, '') || this.buttonOnDefault;
        this.buttonOffDefault =  Assets.get("LandingPageClaroTv_BotonPrimario_ColorBotonPrimario_Btn_ActualizarApagar_Off", '');
        this.buttonOff = Assets.get(`LandingPageClaroTv_BotonPrimario_ColorBotonPrimario_Btn_ActualizarApagar_Off_${region}`, '') || this.buttonOffDefault;

        this.state = {
            imageOnError: false,
            imageOffError: false,
            focus: false
        }
    }

    render(){
        const { imageOnError, imageOffError, focus } = this.state;
        const { buttonOn, buttonOff, buttonOnDefault, buttonOffDefault } = this;
        const { goBack } = this.props;

        return <Button 
                    type="button"
                    variant="primary"
                    className={cls(
                        `focusable`,
                        'btn',
                        `btn-actualizar-al-apagar`
                    )}
                    onClick={() => {
                        const task = new AddAdminDeviceTask();
                        const modal = {
                            modalType: AAF_MODAL_LANDING_STB,
                            modalProps: {
                                callback : () => {
                                    goBack()
                                },
                                isError: false
                            }
                        };
                        RequestManager.addRequest(task).then().catch(_ => {
                            modal.modalProps.isError = true;
                        }).finally(() => {
                            store.dispatch(showModal(modal));
                        })
                    }}
                    onFocus={() => this.setState({focus: true})}
                    onBlur={() => this.setState({focus: false})}

                >
                    <img src={imageOnError ? buttonOnDefault :buttonOn} 
                        onError={imageOnError ? () => {} : () => {
                            this.setState({imageOnError: true})
                        }}
                        style={{display: !focus ? "none" : "block"}}
                    />
                    <img src={imageOffError ? buttonOffDefault : buttonOff} 
                        onError={imageOffError ? () => {} : () => {
                            this.setState({imageOffError: true})
                        }}
                        style={{display: focus ? "none" : "block"}}
                    />
                </Button>
    }
}

export default ButtonActualizarAlApagar;


// WEBPACK FOOTER //
// ./src/components/LandingPage/LandingPageSTB/buttons/ButtonActualizarAlApagar.jsx